import { Box, Grid, Tooltip } from '@mui/joy'
import { myPalette } from '~/shared/lib/theme'
import {
  DateTimePickerInput,
  NumericInput,
  TextInput,
  Switch,
  DetailsInput,
} from '~/shared/ui/Form'
import { InfoCircleIcon } from '~/shared/ui/Icons'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type BasicInfoProps = {
  disabled?: boolean
  skeletonShow?: boolean
  isPromotion?: boolean
}

export function BasicInfo({
  disabled,
  skeletonShow,
  isPromotion,
}: BasicInfoProps) {
  return (
    <Container>
      <ContainerTitle>Основная информация</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid container xs={12}>
          <Grid xs={6}>
            <TextInput
              label='Название'
              name='title'
              placeholder='Название акции'
              readOnly={disabled}
              skeletonShow={skeletonShow}
            />
          </Grid>
          <Grid xs={6}>
            <TextInput
              label='Описание'
              name='description'
              placeholder='Описание акции'
              readOnly={disabled}
              skeletonShow={skeletonShow}
            />
          </Grid>
        </Grid>
        <Grid container xs={12}>
          <Grid xs={6}>
            <TextInput
              label='Промокод'
              name='code'
              placeholder='Промокод'
              readOnly={disabled || isPromotion}
              skeletonShow={skeletonShow}
            />
          </Grid>
          <Grid xs={6}>
            <NumericInput
              label='Использований'
              name='usagesLeft'
              placeholder='Осталось использований'
              readOnly={disabled}
              skeletonShow={skeletonShow}
            />
          </Grid>
        </Grid>
        <Grid container xs={12}>
          <Grid xs={6}>
            <DateTimePickerInput
              name='beginningAt'
              label='Начало'
              placeholder='Начало'
              readOnly={disabled}
              skeletonShow={skeletonShow}
            />
          </Grid>
          <Grid xs={6}>
            <DateTimePickerInput
              name='expiredAt'
              label='Истекает'
              placeholder='Истекает'
              readOnly={disabled}
              skeletonShow={skeletonShow}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2.5}>
        <Grid container xs={12}>
          <Grid xs={12}>
            <DetailsInput
              name='details'
              label='Детали скидки'
              readOnly={disabled}
              skeletonShow={skeletonShow}
            />
          </Grid>
        </Grid>

        <Grid container xs={12}>
          <Grid xs={3}>
            <Switch
              label='Привязан к пользователю'
              name='boundToUser'
              disabled={disabled}
            />
          </Grid>
          <Grid xs={3}>
            <Switch label='Многоразовый' name='multiUse' disabled={disabled} />
          </Grid>
          <Grid xs={3}>
            <Box display='flex' alignItems='center'>
              <Switch label='Акция' name='isPromotion' disabled={disabled} />
              <Tooltip title='Если отключена - это промо код'>
                <Box
                  component='span'
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    mt: '1px',
                  }}
                >
                  <InfoCircleIcon color={myPalette.brand[600]} />
                </Box>
              </Tooltip>
            </Box>
          </Grid>
          <Grid xs={3}>
            <Box display='flex' alignItems='center'>
              <Switch
                label='Первый договор'
                name='isFirstContract'
                disabled={disabled}
              />
              <Tooltip title='Для новых уникальных пользователей'>
                <Box
                  component='span'
                  sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    mt: '1px',
                  }}
                >
                  <InfoCircleIcon color={myPalette.brand[600]} />
                </Box>
              </Tooltip>
            </Box>
          </Grid>
          <Grid container xs={12}>
            <Grid xs={3}>
              <Switch label='Активная' name='isActive' disabled={disabled} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}
